import { useCallback, useState } from 'react'

import { useFormField } from 'cng-common/features/form'

import { controlsInitialData, KEY_INITIATIVE_CONTROLS_FORM } from '../../../configs/config'
import { DashboardChartMeasure, DashboardGroupBy } from '../../../model/types'
import { TListGroupBy, TListMeasure } from '../models'

/** Keep the five existing settings shared with Analysis; list-only choices never leak into its charts. */
export const useListViewSettings = () => {
  const { value: sharedGroupBy, handleChange: changeSharedGroupBy } =
    useFormField<DashboardGroupBy>({
      formKey: KEY_INITIATIVE_CONTROLS_FORM,
      field: 'groupBy',
      defaultValue: controlsInitialData.groupBy,
    })
  const { value: sharedMeasure, handleChange: changeSharedMeasure } =
    useFormField<DashboardChartMeasure>({
      formKey: KEY_INITIATIVE_CONTROLS_FORM,
      field: 'chartMeasure',
      defaultValue: controlsInitialData.chartMeasure,
    })
  const [isUngrouped, setIsUngrouped] = useState(false)
  const [isNoSalesMeasure, setIsNoSalesMeasure] = useState(false)
  const groupBy: TListGroupBy = isUngrouped ? 'none' : sharedGroupBy
  const measure: TListMeasure = isNoSalesMeasure ? 'no-sales-target' : sharedMeasure
  const changeGroupBy = useCallback(
    (value: TListGroupBy) => {
      setIsUngrouped(value === 'none')
      if (value !== 'none') changeSharedGroupBy(value)
    },
    [changeSharedGroupBy]
  )
  const changeMeasure = useCallback(
    (value: TListMeasure) => {
      setIsNoSalesMeasure(value === 'no-sales-target')
      if (value !== 'no-sales-target') changeSharedMeasure(value)
    },
    [changeSharedMeasure]
  )
  return { groupBy, measure, changeGroupBy, changeMeasure }
}
